export default __webpack_public_path__ + "static/media/xharktank.7aa083f1.png";